<template>
    <div v-if="widgetReady">
        <div v-if="plans.length > 0" id="plan-table" class="plans-bar-stack">
            <div
                v-for="plan in plans"
                :key="plan.planId != null ? plan.planId : plan.PlanId"
                class="plans-bar-stack__item"
            >
                <plan :plan="plan" 
                    :hidePlanPrice="hidePlanPrice"
                    :providerEntityId="plan.providerEntityId" 
                    :config-frequencies="frequencyConfig">
                    <template slot="header">
                        <slot :plan="plan"></slot>
                    </template>
                </plan>
            </div>
        </div>
        <div v-else>
            <div class="ac-floating-panel">
                <div class="ac-panel-content ac-white-panel" style="text-align: center;">
                    No eligible plans available for this provider
                </div>
            </div>
        </div>  
    </div>
</template>

<script>
    import Plan from "./Plan.vue";
    import {configTables} from "../../../global/configTables.js";
    import {api} from "../../../global/framework/api.js";

    export default {
        name: "Plans",
        components: {Plan},
        props: {
            plans: {type: [Array], required: true},
            hidePlanPrice: {type: [Boolean], required: false, default: false}
        },
        data() {
            return {
                frequencyConfig: [],
                widgetReady: false
            };
        },
        async mounted() {
            this.frequencyConfig = await configTables.getPlanFrequencies();
            this.widgetReady = true
        },
    }
</script>

<style scoped>
.plans-bar-stack {
    display: flex;
    flex-direction: column;
    gap: 1.75rem;
}

.plans-bar-stack__item {
    min-width: 0;
}

.ac-floating-panel {
    margin-bottom: 10px;
}

.ac-panel-title {
    font-weight: bold;
    font-size: larger;
    color: #3e3f40;
}

.ac-floating-panel .ac-panel-title {
    margin-bottom: 10px;
    display: block;
}

.ac-panel-content {
    padding: 20px;
    box-shadow: 0 1px 4px rgb(0 0 0 / 20%);
}

.ac-white-panel {
    background-color: white;
    border-radius: 10px;
}

.ac-white-panel * {
    color: #3e3f40 !important;
}
</style>